export default "__VITE_ASSET__Dbq5cwpu__"